<template>
  <div class="card-module">
    <div class="flx-between">
      <div class="module-title"><i class="el-icon-star-off" /> {{ $t('home.funcFavorites') }}</div>
      <div class="point" @click="showSetFavoritesItemDialog">
        <i class="el-icon-setting" style="font-size: 25px" />
      </div>
    </div>

    <div class="button-grid">
      <div
        v-for="(item, index) in searchMenuList"
        :key="index"
        class="favoritesItem"
        @click="toMenu(item)"
      >
        <div class="favoritesName">{{ item.name }}</div>
      </div>
    </div>
    <favorites
      ref="favoritesRef"
      :pc-menu-list="menuList"
      :show-menu-list="searchMenuList"
      @childrenSearch="childrenSearch"
    />
  </div>
</template>

<script>
import { queryMenu } from '@/api/user';
import { RouterObj } from '@/lang/type/route';
import favorites from '@/views/dashboard/component/favorites.vue';

export default {
  components: {
    favorites
  },
  data() {
    return {
      routerObjLang: RouterObj,
      searchMenuList: [],
      menuList: []
    };
  },
  mounted() {
    this.openSearchMenu();
    this.childrenSearch();
  },
  methods: {
    getSearchMenuList() {
      const data = {
        source: 1,
        userId: this.$store.state.user.id
      };
      this.searchMenuList = [];
      queryMenu(data).then((res) => {
        if (res.code === 200) {
          this.mergeMenuTitles(res.data.menuTitle || []);
        }
        console.log('this.getSearchMenuList.query', this.searchMenuList);
      });
    },
    openSearchMenu() {
      const arr = this.extractRoutes(this.$store.getters.addRoutes);
      // 去到数组第一个
      arr.splice(0, 1);
      arr.forEach((item) => {
        try {
          if (this.$i18n.locale !== 'zh') {
            item.name = this.routerObjLang[item.title].pu;
          } else {
            item.name = this.routerObjLang[item.title].zh;
          }
        } catch (error) {
          console.log(error, 'error');
        }
      });
      this.menuList = arr;
      console.log(arr, 'arr');
    },
    // 递归过滤
    extractRoutes(routes, parentPath = '', result = [], leave = 0) {
      routes.forEach((route) => {
        let currentPath = route.path;
        if (parentPath && currentPath) {
          currentPath = `${parentPath}/${currentPath}`;
        }
        const title = route.meta && route.meta.title;
        const fillterRouter = route.fillterRouter;
        if (title && currentPath && leave > 0) {
          // 判断把一级的路由过滤
          if (fillterRouter !== true) {
            result.push({ title, path: currentPath, leave, fillterRouter });
          }
        }
        if (route.children && route.children.length > 0) {
          this.extractRoutes(route.children, currentPath, result, leave + 1);
        }
      });
      return result;
    },
    toMenu(item) {
      this.$router.push(item.path);
    },
    // 点击设置收藏夹
    showSetFavoritesItemDialog() {
      this.$refs.favoritesRef.showSetFavoritesItemDialog();
    },
    //  查询收藏夹
    childrenSearch() {
      const data = {
        source: 1,
        userId: this.$store.state.user.id
      };
      this.searchMenuList = [];
      queryMenu(data).then((res) => {
        if (res.code === 200) {
          this.mergeMenuTitles(res.data.menuTitle || []);
        }
      });
    },
    // 将接口返回的 title 映射为菜单对象，并按 path 去重合并
    mergeMenuTitles(menuTitles) {
      menuTitles.forEach((title) => {
        const obj = this.menuList.find((item) => item.title === title);
        if (obj && !this.searchMenuList.some((m) => m.path === obj.path)) {
          this.searchMenuList.push(obj);
        }
      });
    }
  }
};
</script>

<style scoped>
.card-module {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 10px;
}

.module-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
}

.module-title i {
  margin-right: 8px;
  color: #f5a623;
}

.button-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.tag-btn {
  padding: 10px 18px;
  background: #fafafa;
  border-color: #ebeef5;
}

.favoritesItem {
  padding: 8px;
  border: 1px solid #bbbbbb;
  border-radius: 10px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 14px;
}

/* 鼠标 hover 容器时：加浅背景（可选，增强交互反馈） */
.favoritesItem:hover {
  background-color: #42b983; /* 淡灰色背景，适配大多数 UI 风格 */
}

/* 名称样式：默认显示，控制间距 */
.favoritesName {
  /*margin-right: 10px;*/
  white-space: nowrap; /* 防止名称换行导致布局错乱 */
}
</style>
